module.exports = __webpack_public_path__ + "img/ncdc_logo_1.aa138826.png";